const scale = ['Bytes', 'kB', 'MB'];
export default function abbreviateFileSize(value, order = 0) {
  if (value < 1024) {
    return `${+value.toFixed(1)} ${scale[order]}`;
  }
  return abbreviateFileSize(value / 1024, order + 1);
}
